import { Box, FloraButton, Flex, FloraTypography } from '@grupoboticario/flora-react'

import { BackofficeImage } from '@/components/BackofficeImage/BackofficeImage'
import { useUserContext } from '@/context/user'
import {
  getTestTokenAdmin,
  getTestTokenAntiFraud,
  getTestTokenCrm,
  getTestTokenLgpd,
  getTestTokenService,
  getTestTokenServiceFranchised,
  isTestUsersEnabled
} from '@/utils/envUtils'
import { isBrowser } from '@/utils/isBrowser'
import { theme } from '@/utils/themes/theme'

import * as L from './login.styles'

const Login = () => {
  const { setUserByToken, login } = useUserContext()

  return (
    isBrowser() && (
      <Box>
        <Flex css={L.outerFlexCss}>
          <Flex align="center" css={L.sidebarCss} justify="center">
            <Box
              alt="Logo da marca"
              as="img"
              css={L.logoImageCss}
              priority="true"
              src={`/img/logos/${theme(isBrowser() ? globalThis?.location?.hostname : '')}.svg`}
            />
          </Flex>
          <Flex align="center" css={L.contentFlexCss} justify="center">
            <Box css={L.contentBoxCss}>
              <Flex direction="column" gap="$3">
                <FloraTypography as="span" fontSize="title">
                  Olá! Seja bem-vindo(a).
                </FloraTypography>
                <FloraTypography fontSize="bodyLargeShort">
                  Por favor, informe seu login e senha do Grupo Boticário para acessar o BackOffice do Fidelidade.
                </FloraTypography>
              </Flex>
              <Flex css={L.loginButtonRowCss} justify="center">
                <Box
                  alt="Entrar com a Microsoft"
                  as={BackofficeImage}
                  css={L.loginImageCss}
                  height={41}
                  onClick={() => login()}
                  src="/img/login-with-microsoft.svg"
                  width={215}
                />
              </Flex>
              {isTestUsersEnabled() && (
                <Flex css={L.testUsersRowCss} direction="column" justify="flex-end">
                  <FloraButton onClick={() => setUserByToken(getTestTokenAdmin())} size="small" hierarchy="tertiary">
                    Acessar como usuário administrador
                  </FloraButton>
                  <FloraButton onClick={() => setUserByToken(getTestTokenLgpd())} size="small" hierarchy="tertiary">
                    Acessar como usuário de LGPD
                  </FloraButton>
                  <FloraButton
                    onClick={() => setUserByToken(getTestTokenAntiFraud())}
                    size="small"
                    hierarchy="tertiary"
                  >
                    Acessar como usuário de antifraude
                  </FloraButton>
                  <FloraButton onClick={() => setUserByToken(getTestTokenCrm())} size="small" hierarchy="tertiary">
                    Acessar como usuário de CRM
                  </FloraButton>
                  <FloraButton onClick={() => setUserByToken(getTestTokenService())} size="small" hierarchy="tertiary">
                    Acessar como usuário de atendimento
                  </FloraButton>
                  <FloraButton
                    onClick={() => setUserByToken(getTestTokenServiceFranchised())}
                    size="small"
                    hierarchy="tertiary"
                  >
                    Acessar como usuário de atendimento franqueado
                  </FloraButton>
                </Flex>
              )}
            </Box>
          </Flex>
        </Flex>
      </Box>
    )
  )
}

export default Login

export { Login as LoginPage }
